<template>
  <main>
    <div class="user">
      <div class="info">
        <img :src="userInfo.headImg" alt="">
        <div>
          <h3>{{userInfo.userName}}</h3>
          <p>{{userInfo.phoneNum}}</p>
        </div>
      </div>
      <div class="count">
        <div>
          <h3>0</h3>
          <p>积分</p>
        </div>
        <div>
          <h3>0.00</h3>
          <p>余额</p>
        </div>
        <div>
          <h3>0</h3>
          <p>卡券</p>
        </div>
      </div>
    </div>
    <div class="link">
      <div>
        <p>在线充值</p>
        <img src="../assets/3.png" alt="">
      </div>
      <div @click="link('/userinfo')">
        <p>个人信息</p>
        <img src="../assets/3.png" alt="">
      </div>
      <div @click="link('/mycar')">
        <p>我的车辆</p>
        <img src="../assets/3.png" alt="">
      </div>
      <div @click="link('/invoice')">
        <p>发票申请</p>
        <img src="../assets/3.png" alt="">
      </div>
      <div @click="link('/problem')">
        <p>常见问题</p>
        <img src="../assets/3.png" alt="">
      </div>
      <div @click="link('/opinion')">
        <p>意见反馈</p>
        <img src="../assets/3.png" alt="">
      </div>
    </div>
    <tabbar current="4"></tabbar>
  </main>
</template>

<script>
    import tabbar from '../components/Tabbar.vue'
    import API from "../api/index"
    import { StringUtil, Cookies } from '../util/index'
    
    export default {
        name: "my",
        components: {tabbar},

        data() {
          return {
            userInfo: [],
          }
        },
        mounted() {
          var _this=this;

          this.$http({
          method:'post',
          data: {
            userId:Cookies.get("userId"),
            userType:Cookies.get("userType"),
          },
          url:API.loadUserInfo_url
              }).then(function(resp){
                  console.log(resp.data);
                  if(resp.data.returnCode == 'SUCCESS') {
                    _this.userInfo=resp.data.data;
                    if(resp.data.data.phoneNum) {
                        Cookies.set('phoneNum',resp.data.data.phoneNum)                         
                    }
                     if(resp.data.data.uId) {
                        Cookies.set('uId',resp.data.data.uId)                         
                    }                    
                  } 

                }).catch(resp => {
                  console.log('请求失败：'+resp.status+','+resp.statusText);
          });
        },

        methods: {
            link(url) {
                this.$router.push(url)
            }
        }
    }
</script>

<style scoped>
  .user {
    margin: 0 20px;
    background: #fff;
    box-shadow: 0 0 10px #ccc;
  }

  .user .info {
    display: flex;
    align-items: center;
    padding: 20px 30px;
  }

  .user .info img {
    width: 90px;
  }

  .user .info div {
    margin-left: 20px;
  }

  .user .info div h3 {
    font-size: 30px;
  }

  .user .info div p {
    color: #999;
    font-size: 24px;
    margin-top: 10px;
  }

  .user .count {
    display: flex;
    align-items: center;
    padding: 20px 0;
  }

  .user .count div {
    flex: 1;
    text-align: center;
  }

  .user .count div h3 {
    font-size: 30px;
  }

  .user .count div p {
    font-size: 24px;
    color: #999;
    margin-top: 20px;
  }

  .link {
    margin: 20px;
    background: #fff;
    box-shadow: 0 0 10px #ccc;
  }

  .link div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 80px;
    padding: 0 20px;
  }

  .link div + div {
    border-top: 1px solid #ccc;
  }

  .link div p {
    font-size: 26px;
  }

  .link div img {
    width: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/my.vue